import { useEffect, useState } from 'react';

const useFormResetKey = (touched: boolean) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!touched) {
            setCount(count => count + 1);
        }
    }, [touched]);

    return count;
};

export { useFormResetKey };
